import React, { useState } from 'react'
import { useSelector } from 'react-redux'
import { useTranslation } from 'react-i18next'
import moment from 'moment'
import { useTheme } from '@material-ui/core/styles'
import {
  InfoRounded as InfoIcon,
  BookmarkRounded as BookmarkIcon,
} from '@material-ui/icons'

import { isArray } from '../../../utils/customMethods'
import { CircularProgress } from '@material-ui/core'

import BalloonSystem from '../../atoms/balloons/balloonSystem'
import BalloonConsumer from '../../atoms/balloons/balloonConsumer'
import BalloonTime from '../../atoms/balloons/balloonTime'
import BalloonAgent from '../../atoms/balloons/balloonAgent'
import Gallery from '../galleries/chatPictures'
import Typography from '../../atoms/display/typography'
import EmptyState from '../../atoms/display/emptyState'

import useStyles from './historyBookmarkStyle'

const HistoryBookmark = (props) => {
  const undock = useSelector((state) => state.undock)

  const { t } = useTranslation()
  const theme = useTheme()
  const classes = useStyles()

  const favoriteMessages = useSelector((state) => state.favoriteMessages)

  const [galleryOpen, setGalleryOpen] = useState(false)

  const activeConversation = undock.data
    ? undock.activeConversation
    : useSelector((state) => state.activeConversation)
  const history = useSelector((state) => state.history)
  const messageStore = useSelector((state) => state.conversations.messages)

  const renderBallonBySenderType = (el) => {
    if (el.by === 'system' || el.by === 'bot') {
      return (
        <BalloonSystem
          data={el}
          showBookmark={false}
          style={{ cursor: 'pointer' }}
          onClick={() => {
            document.getElementById(el.currentId).scrollIntoView()
          }}
        />
      )
    }
    if (el.by === 'consumer') {
      return (
        <BalloonConsumer
          data={el}
          showBookmark={false}
          style={{ cursor: 'pointer' }}
          onClick={() => {
            document.getElementById(el.currentId).scrollIntoView()
          }}
        />
      )
    }
    if (el.by === 'agent' || el.by === 'manager') {
      return (
        <BalloonAgent
          data={el}
          showBookmark={false}
          style={{ cursor: 'pointer' }}
          onClick={() => {
            document.getElementById(el.currentId).scrollIntoView()
          }}
        />
      )
    }
  }

  // TODO: update this method with new components
  const renderMessages = () => {
    const consumerId = props?.consumerId
    const chatId = props?.chatId
    const favorites =
      consumerId && chatId
        ? favoriteMessages.conversations[chatId]
        : !props?.isHistoryNotes
        ? messageStore[activeConversation]?.filter((el) => el?.favorite)
        : null

    if (favorites?.length > 0) {
      let dividerText = null
      return (
        <>
          <div className={classes.info}>
            <InfoIcon
              style={{ color: theme.palette.hover2, marginRight: 10 }}
            />
            <Typography variant="body1">
              {t('alerts.shortcutNotes')}{' '}
            </Typography>
          </div>
          {favorites.map((el) => {
            if (
              !dividerText ||
              dividerText !== moment(el.sentTime).format('DD/MM')
            ) {
              dividerText = moment(el.sentTime).format('DD/MM')
              return (
                <>
                  <BalloonTime time={dividerText} />
                  {renderBallonBySenderType(el)}
                </>
              )
            } else {
              return renderBallonBySenderType(el)
            }
          })}
        </>
      )
    } else {
      return !isArray(favoriteMessages.conversations[chatId]) &&
        favoriteMessages?.status?.get_favorite_messages?.loading ? (
        <div className={classes.loadingSection}>
          <CircularProgress size={25} color="primary" />
        </div>
      ) : (
        <>
          <EmptyState text={t('alerts.noMessagesFound')}>
            <BookmarkIcon />
          </EmptyState>
        </>
      )
    }
  }

  return (
    <>
      <div className={classes.content}>{renderMessages()}</div>
      {galleryOpen && (
        <Gallery open={galleryOpen} openCallback={() => setGalleryOpen()} />
      )}
    </>
  )
}

export default HistoryBookmark
